export const defaultConditionsProps = {
  hiddenIfLoggedIn: false,
  hiddenIfNotLoggedIn: false,
  hiddenIfMember: false,
  hiddenIfNotMember: false,
  hiddenIfDesktop: false,
  hiddenIfTablet: false,
  hiddenIfMobile: false,
}

export const conditions = {
  'Utente': {
    hiddenIfLoggedIn: {
      description: "Nascondi se l'utente è loggato",
    },
    hiddenIfNotLoggedIn: {
      description: "Nascondi se l'utente non è loggato",
    },
    hiddenIfMember: {
      description: "Nascondi se l'utente è un membro",
    },
    hiddenIfNotMember: {
      description: "Nascondi se l'utente non è un membro",
    },
  },
  'Screen Size': {
    hiddenIfDesktop: {
      description: 'Nascondi se in modalità desktop',
    },
    hiddenIfTablet: {
      description: 'Nascondi se in modalità tablet',
    },
    hiddenIfMobile: {
      description: 'Nascondi se in modalità smartphone',
    },
  },
}
